import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import '../../styles/TopNavBar.css';
import RibbonLogo from '../../images/topnavbar2.png';
import CartLink from '../DeviceRequests/CartLink';
import NotificationBell from './NotificationBell';

// The bar used to carry a live username/password form. Two inputs and a submit
// button inside a 48px-tall fixed header is cramped on desktop and unusable on
// a phone, and it put a credential form on every page in the app — including
// the ones you can only reach while already logged in. There is a /login route
// already; this links to it.
//
// `onLogin` is still accepted so App.js does not need changing, and so the prop
// is there if a quick-login is ever wanted back.

export default function TopNavBar2({ user, onLogout }) {
    const [open, setOpen] = useState(false);
    const role = localStorage.getItem("role");

    const close = () => setOpen(false);

    // NavLink gives us the active state for free, which is what tells someone
    // which section they are in.
    const link = ({ isActive }) =>
        "top-nav-link" + (isActive ? " is-active" : "");

    return (
        <header className="top-nav-bar">
            <Link to="/" className="top-nav-logo-link" onClick={close}>
                <img src={RibbonLogo} alt="WallBurst" className="top-nav-logo" />
            </Link>

            <button
                type="button"
                className="top-nav-toggle"
                aria-expanded={open}
                aria-controls="top-nav-menu"
                onClick={() => setOpen((v) => !v)}
            >
                Menu
            </button>

            {/* `hidden` rather than conditional rendering: the desktop layout
                shows this regardless, and the attribute is what the media query
                keys off. */}
            <nav id="top-nav-menu" className="top-nav-bar-content" hidden={!open}>
                {user ? (
                    <>
                        {role === "vendor" && (
                            <>
                                <NavLink to="/devices" className={link} onClick={close}>Browse</NavLink>
                                <NavLink to="/vendor-dashboard" className={link} onClick={close}>Dashboard</NavLink>
                                <NavLink to="/vendor/requests" className={link} onClick={close}>Requests</NavLink>
                                <NavLink to="/vendor-profile" className={link} onClick={close}>Profile</NavLink>
                            </>
                        )}
                        {role === "customer" && (
                            <>
                                {/* Mirrors the broadcaster's bar. The four
                                    advertiser sections used to live up here
                                    while the broadcaster had a sidebar, so the
                                    same product had two different shapes
                                    depending on which side you were on. They
                                    are tabs in the dashboard now; the cart
                                    stays because it is a flow, not a section. */}
                                <NavLink to="/devices" className={link} onClick={close}>Browse</NavLink>
                                <NavLink to="/customer/ads" className={link} onClick={close}>Dashboard</NavLink>
                                <CartLink className="top-nav-link" />
                            </>
                        )}
                        {/* One bell for the whole account, outside both role
                            branches. A dual-role user has one feed (the server
                            assembles both sides), so two bells would be two
                            places to look and one of them always stale. */}
                        <NotificationBell className="top-nav-bell" />
                        <span className="top-nav-divider" aria-hidden="true" />
                        <span className="top-nav-user">{user}</span>
                        <button
                            type="button"
                            className="wb-btn wb-btn--secondary wb-btn--sm"
                            onClick={() => { close(); onLogout && onLogout(); }}
                        >
                            Log out
                        </button>
                    </>
                ) : (
                    <>
                        <NavLink to="/devices" className={link} onClick={close}>Explore locations</NavLink>
                        <NavLink to="/waitlist" className={link} onClick={close}>Become a host</NavLink>
                        <NavLink to="/how-it-works" className={link} onClick={close}>How it works</NavLink>
                        <span className="top-nav-divider" aria-hidden="true" />
                        <Link to="/login" className="wb-btn wb-btn--ghost wb-btn--sm" onClick={close}>
                            Log in
                        </Link>
                        <Link to="/register/customer" className="wb-btn wb-btn--primary wb-btn--sm" onClick={close}>
                            Get started
                        </Link>
                    </>
                )}
            </nav>
        </header>
    );
}
